import {Injectable} from "@angular/core";
import {Actions, createEffect, Effect, ofType} from "@ngrx/effects";
import {Store} from "@ngrx/store";
import {IAppState} from "../../state/app.state";
import {EAuthenticatedUserActions, LoadAuthenticatedUser, LoadAuthenticatedUserFailure, LoadAuthenticatedUserSuccess, LoadSelectedPartyProfile, LoadSelectedPartyProfileFailure, LoadSelectedPartyProfileSuccess} from "../../actions/security/authenticated-user.actions";
import {catchError, concatMap, concatMapTo, map, mapTo, switchMap, withLatestFrom} from "rxjs/operators";
import { IUser, IUserProfile} from "../../models/security/user-profile.interface";
import {of} from "rxjs";
import {ApiPlatformService} from "../../../../api/external/api-services/api-platform/api-platform.service";
import {emptyParty, IParty} from "@retail-data-factory/rdf-angular-types-api";
import {Logout} from "../../actions/security/authentication.actions";
import {MessageService} from "@retail-data-factory/rdf-angular-messages";
import {AssistTranslationService} from "@retail-data-factory/rdf-angular-translation-service";
import {GetResources} from "../../actions/resources/resources.actions";

@Injectable()
export class AuthenticatedUserEffects {
  LoadAuthenticatedUser$ =  createEffect(() => this._actions$.pipe(
    ofType<LoadAuthenticatedUser>(EAuthenticatedUserActions.LoadAuthenticatedUser),
    withLatestFrom(this._store$),

    switchMap(([action,storeState]) => {
      return this.apiPlatformService.getAuthenticatedUserProfile(storeState.authentication.data.accessToken)
        .pipe(
          map(
            result =>{
              console.log('getUser effect');
              console.log(result);
              if (result['report'].length>0) {
                const userProfile: IUserProfile = {
                  deliverySiteId: result['report'][0]['profile'] && result['report'][0]['profile']['delivery_site_id']?result['report'][0]['profile']['delivery_site_id']:'',
                  department: result['report'][0]['profile'] && result['report'][0]['profile']['department']?result['report'][0]['profile']['department']:'',
                  firstName: result['report'][0]['profile'] && result['report'][0]['profile']['FirstName']?result['report'][0]['profile']['FirstName']:'',
                  lastName: result['report'][0]['profile'] && result['report'][0]['profile']['LastName']?result['report'][0]['profile']['LastName']:'',
                  phone1: result['report'][0]['profile'] && result['report'][0]['profile']['Phone1']?result['report'][0]['profile']['Phone1']:'',
                  phone2: result['report'][0]['profile'] && result['report'][0]['profile']['Phone2']?result['report'][0]['profile']['Phone2']:'',
                  jobTitle: result['report'][0]['profile'] && result['report'][0]['profile']['job_title']?result['report'][0]['profile']['job_title']:''
                };
                userProfile.firstName = result['report'][0]['FirstName']?result['report'][0]['FirstName']:'';
                userProfile.lastName = result['report'][0]['LastName']?result['report'][0]['LastName']:'';

                if (!userProfile.firstName && !userProfile.lastName) {
                  userProfile.firstName = result['report'][0]['Login'];
                }
                const user: IUser = {
                  id: result['report'][0]['ID'],
                  email: result['report'][0]['Email'],
                  login: result['report'][0]['Login'],
                  userType: result['report'][0]['TypeUser'],
                  userProfile: userProfile,

                  selectedPartyId: result['report'][0]['PartyID'],
                  //partyType: result['report'][0]['TypeParty'],
                  availableParty: [],
                  selectedPartyProfile: null

                };
                if (result['report'][0].blocked ===1) {
                  setTimeout(() => this.messageService.error('Retail Data Factory', this.assistTranslationService.getServiceErrorMessage(30,'common.unknownError' )), 1000);
                  return new Logout();
                }
                return new LoadAuthenticatedUserSuccess(user);
              } else {
                return new LoadAuthenticatedUserFailure();
              }
          }
          ),
          catchError(error => {
            console.log(error);
            return of(new LoadAuthenticatedUserFailure());
          })

        );
      }
    )
  ));
  LoadAuthenticatedUserSuccess$ =  createEffect(() => this._actions$.pipe(
    ofType<LoadAuthenticatedUserSuccess>(EAuthenticatedUserActions.LoadAuthenticatedUserSuccess),
    //mapTo(new LoadSelectedPartyProfile())
    withLatestFrom(this._store$),
    concatMap(([action,storeState]) =>[
      new LoadSelectedPartyProfile(),
      //new SetDatasourcePartyId(storeState.authenticatedUser.data.selectedPartyId)
    ])

  ));
  LoadAuthenticatedUserFailure$ =  createEffect(() => this._actions$.pipe(
    ofType<LoadAuthenticatedUserSuccess>(EAuthenticatedUserActions.LoadAuthenticatedUserFailure),
    //mapTo(new LoadSelectedPartyProfile())
    withLatestFrom(this._store$),
    concatMap(([action,storeState]) =>[
      new Logout()
    ])

  ));
  LoadSelectedPartyProfile$ =  createEffect(() => this._actions$.pipe(
    ofType<LoadAuthenticatedUser>(EAuthenticatedUserActions.LoadSelectedPartyProfile),
    withLatestFrom(this._store$),
    switchMap(([action,storeState]) => {
        return this.apiPlatformService.getPartyProfile(storeState.authentication.data.accessToken)
          .pipe(
            map(
              result =>{
                console.log('getUser effect');
                console.log(result);

                if (result['report'].length>0) {
                  let partyName =  result['report'][0]['Name']?result['report'][0]['Name']:'';
                  if (!partyName) {
                    partyName = result['report'][0]['profile']&& result['report'][0]['profile']['LegalName']?result['report'][0]['profile']['LegalName']:'';
                  }
                  const party: IParty = {
                    ...emptyParty,
                    id: result['report'][0]['ID'],
                    name: partyName,
                    typeCode: result['report'][0]['TypeCode'],
                    legalId: result['report'][0]['LegalID']?result['report'][0]['LegalID']:'',
                    phone: result['report'][0]['profile']['phone'],
                    email: result['report'][0]['profile']['email'],
                    startPage: result['report'][0]['profile']['start_page']?result['report'][0]['profile']['start_page']:'',
                    statusCode: result['report'][0]['StatusCode'],
                    kpp: result['report'][0]['profile']['KPP'],
                    legalAddress: result['report'][0]['profile']['LegalAddress'],
                    parentRelationshipStatus: result['report'][0]['ParentRelationshipStatus'],
                    childRelationshipStatus:  result['report'][0]['ChildRelationshipStatus'],

                  };
                  this._store$.dispatch(new GetResources());
                  return new LoadSelectedPartyProfileSuccess(party);
                } else {
                  return new LoadSelectedPartyProfileFailure();
                }
              }
            ),
            catchError(error => {
              console.log(error);
              return of(new LoadSelectedPartyProfileFailure());
            })

          );
      }
    )
  ));


  constructor(
//    private _userService: UserService,
    private apiPlatformService: ApiPlatformService,
    private _actions$: Actions,
    private messageService: MessageService,
    private assistTranslationService: AssistTranslationService,
    private _store$: Store<IAppState>
) {}

}
